// https://companywelfaresvil.poste.it/shopping/staticapi/v1/orders/1204462b-fd00-48bf-aaf0-8fcbbff08583
import type { refundApi } from 'app/src/services/welfareportal'
import { DateTime } from 'luxon'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const getRefunds = http.get<object, object, refundApi.RefundPaginated>(apiBaseUrl + '/refunds', async ({ request }) => {
  const url = new URL(request.url)
  const status = url.searchParams.get('status')
  const sort = url.searchParams.get('sort')
  const from = url.searchParams.get('from')
  const to = url.searchParams.get('to')
  const offset = url.searchParams.get('pagingOffset')
  const limit = url.searchParams.get('pagingLimit')
  const membershipId = url.searchParams.get('membershipId')

  const refunds = await (await fetch('./data/refund/refunds.json')).json()

  let items: refundApi.Refund[] = (refunds?.items || []).filter(
    (item: refundApi.Refund) => item?.attributes?.userMembershipId === membershipId,
  )

  if (sort == '+date') {
    items = items.sort((a, b) => DateTime.fromISO(a.date).toMillis() - DateTime.fromISO(b.date).toMillis())
  }

  if (sort == '-date') {
    items = items.sort((a, b) => DateTime.fromISO(b.date).toMillis() - DateTime.fromISO(a.date).toMillis())
  }

  if (status !== null) {
    items = items.filter((item) => status?.split(',').includes(item.status.value))
  }

  let fromDate = undefined
  let toDate = undefined
  if (from !== null) {
    fromDate = DateTime.fromISO(from).toMillis()
  }
  if (to !== null) {
    toDate = DateTime.fromISO(to).toMillis()
  }

  items = items.filter((item) => {
    const orderDate = DateTime.fromISO(item.date)

    if (fromDate && toDate) {
      return orderDate.toMillis() >= fromDate && orderDate.toMillis() <= toDate
    } else if (fromDate) {
      return orderDate.toMillis() >= fromDate
    } else if (toDate) {
      return orderDate.toMillis() <= toDate
    } else {
      return true
    }
  })

  const totItems = items.length

  const offsetInt = offset ? parseInt(offset, 10) : 0
  const limitInt = limit ? parseInt(limit, 10) : 2

  items = items.slice(offsetInt, offsetInt + limitInt)

  const refundListResponse: refundApi.RefundPaginated = {
    items: items,
    paging: {
      limit: limitInt,
      offset: offsetInt,
      total: totItems,
    },
  }
  return HttpResponse.json(refundListResponse)
})
